/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterLocation_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterDeliveryOptions_itemSearch";
};
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch$data = SbSharedRefineMenuFilterDeliveryOptions_itemSearch;
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterDeliveryOptions_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterDeliveryOptions_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterDeliveryOptions_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterLocation_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'd5e62a0b54beeb62c5d83d070b4fb0bb';
export default node;
